import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { motion } from 'framer-motion';

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={toggleTheme}
      data-testid="theme-toggle"
      className="fixed bottom-8 right-8 z-50 w-14 h-14 rounded-full bg-purple-600 hover:bg-purple-700 shadow-lg flex items-center justify-center transition-all hover:shadow-[0_0_30px_rgba(124,58,237,0.6)]"
      aria-label="Toggle theme"
    >
      {theme === 'dark' ? (
        <Sun size={24} className="text-white" />
      ) : (
        <Moon size={24} className="text-white" />
      )}
    </motion.button>
  );
};